import { render, staticRenderFns } from "./EmptyPlaceholder.vue?vue&type=template&id=75041305"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./EmptyPlaceholder.vue?vue&type=style&index=0&id=75041305&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports